import { Component } from '@angular/core';
import { DynamicSvgComponent } from '../dynamic-svg/dynamic-svg.component';

@Component({
  selector: 'app-contact-links',
  imports: [DynamicSvgComponent],
  templateUrl: './contact-links.component.html',
  styleUrl: './contact-links.component.scss',
})
export class ContactLinksComponent {

}
